import React from 'react';
import CollectionLoginModal from './CollectionLoginModal/CollectionLoginModal';
import NoPodcastIcon from 'components/svg/NoPodcastIcon';
import CONTENT_TYPES from '../../../globalConst/contentTypes-const';

interface CollectionLogin {
  contentTypeId: string;
}

const modalTitle = {
  clipsInProgress: 'Log in om je favoriete podcast verder te luisteren',
};

const CollectionLogin = ({ contentTypeId }: CollectionLogin): JSX.Element => {
  switch (contentTypeId) {
    case CONTENT_TYPES.CLIP_COLLECTION:
    case CONTENT_TYPES.CONTINUE_LISTENING_CLIP_COLLECTION:
      return (
        <CollectionLoginModal
          data-testid="collection-login-continueListening"
          icon={<NoPodcastIcon />}
          title={modalTitle.clipsInProgress}
        />
      );
    default:
      return <div data-testid="collection-login" />;
  }
};

export default CollectionLogin;
